module.exports = __webpack_public_path__ + "img/ba.f8482723.png";